export type UpsellResponse = Readonly<{
  UpsellOptionId?: number,
  UpsellOptions: UpsellOptions[]
  UpsellAvailableUntil: string,
  UpsellId: string,
  UpsellInclusionTypes?: UpsellInclusionType[],
  AirlineCode?: string,
  PriceChanged: boolean,
  HasPrivateFare?: boolean
}>;

export type UpsellOptions = Readonly<{
  Amount: UpsellAmount,
  Families: UpsellFamilies[],
  OptionId: number,
  HasPrivateFare: boolean,
  CabinTypeByFlights?: number[]
}>;

export type UpsellFamilies = Readonly<{
  Code: string,
  Name: string,
  Inclusions: UpsellInclusions[],
  Sector?: number
}>;

export type UpsellInclusions = Readonly<{
  Type: InclusionType,
  Code: string,
  RowName: string,
  Title: string,
  SubTitle?: string,
  Order: number
}>;

export type UpsellInclusionType = Readonly<{
  Code: string,
  Title: string,
  Type: InclusionType
}>;

export type UpsellAmount = Readonly<{
  CurrencyCode: string,
  Fare: number,
  Taxes: number
}>;

export type UpsellDataVM = Readonly<{
  optionType: UpsellInclusions,
  optionInclusions: UpsellOptionInclusionVM[],
}>;

export type UpsellOptionInclusionVM = Readonly<{
  option: UpsellOptions, 
  family: string
  inclusionInfo: string
}>;

export enum InclusionType {
  Included = 'Included',
  AtCharge = 'AtCharge',
  NotOffered = 'NotOffered'
}
